export const tableStyles = {
  table: {
    width: "100%",
    borderCollapse: "collapse" as const,
    border: "1px solid #DEDEDE",
  },
  th: {
    backgroundColor: "#333",
    color: "#F7F7F7",
    padding: "10px",
    textAlign: "left" as const,
    fontWeight: "bold",
    border: "1px solid #DEDEDE",
    maxWidth: "200px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  td: {
    padding: "8px",
    border: "1px solid #DEDEDE",
    backgroundColor: "white",
    color: "#6D6D6D",
    whiteSpace: "nowrap",
  },
  tr: {
    ":hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  overflowContainer: {
    overflowX: "auto" as const,
    ".MuiPaper-root": {
      borderRadius: "0px",
    },
  },
  noData: {
    padding: "15px",
    border: "1px solid #DEDEDE",
    borderRadius: "0px",
  },
  h2: {
    color: "#07090C",
  },
  p: {
    color: "#6D6D6D",
  },
};
